export default function SvgArrow({ type = "down" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="11"
      viewBox="0 0 19 11"
      fill="none"
    >
      <path
        d="M1 1L9.5 9L18 1"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
